import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Download, FileArchive, Loader2 } from "lucide-react";
import { API, authHdr } from "./AssociateFields";

export const EmployeeDownloads = ({ doc }) => {
  const [busy, setBusy] = useState(false);
  const zip = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/employees/${doc.id}/zip`, { headers: authHdr() });
      if (!r.ok) throw new Error();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(await r.blob()); a.download = `${doc.name || "employee"}_documents.zip`; a.click();
    } catch { toast.error("Download failed"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-8" data-testid="employee-downloads-tab">
      <section className="space-y-3">
        <h3 className="text-xs font-bold uppercase tracking-wider text-teal-700">Download</h3>
        <div className="flex items-center gap-3 rounded-md border p-3 md:w-1/2">
          <FileArchive className="h-8 w-8 text-teal-700" />
          <div className="flex-1"><div className="text-sm font-semibold">All documents (ZIP)</div><div className="text-xs text-gray-500">Every uploaded document in one file</div></div>
          <Button size="sm" className="bg-[#1a7f6f] hover:bg-[#166a5c]" disabled={busy} onClick={zip} data-testid="employee-zip-download">
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />}</Button>
        </div>
      </section>
    </div>
  );
};
